import { ReactNode } from 'react'

import {
  datachainDocsUrl,
  // careersUrl,
  privacyPolicyUrl
} from '@/constants/externalUrls'
import {
  blogsPageLink,
  pricingPageLink,
  securityAndPrivacyPageLink
} from '@/constants/internalLinks'

type Item = {
  name: string
  link: string
  description?: string
  icon?: ReactNode
}

export type MenuItem = {
  name: string
  items?: Item[]
  link?: string
}

const menuItems: MenuItem[] = [
  {
    name: `Blog`,
    link: blogsPageLink
  },
  {
    name: `Docs`,
    link: datachainDocsUrl
  },
  {
    name: `Company`,
    items: [
      {
        name: `Security and Privacy`,
        link: securityAndPrivacyPageLink
      },
      {
        name: `Privacy Policy`,
        link: privacyPolicyUrl
      }
    ]
  },
  {
    name: `Pricing`,
    link: pricingPageLink
  }
]

export default menuItems
